import { useState, useCallback } from 'react'

const getGroupImageIds = (group) => group.images.map((image) => image.id)

const getVariantImageIds = (variant) =>
  variant.groups.flatMap((group) => getGroupImageIds(group))

const getAllImageIds = (variants) =>
  (variants ?? []).flatMap((variant) => getVariantImageIds(variant))

// hook
export default function useGeneratedModal(variants = []) {
  const [selectedVariants, setSelectedVariants] = useState(() => getAllImageIds(variants))

  const getSelectedCountForVariant = useCallback((variant) => {
    const variantImageIds = new Set(getVariantImageIds(variant))
    return selectedVariants.filter((id) => variantImageIds.has(id)).length
  }, [selectedVariants])

  const getTotalCountForVariant = useCallback((variant) =>
    variant.groups.reduce((acc, group) => acc + group.images.length, 0),
  [])

  const isGroupFullySelected = useCallback((group) => {
    const imageIds = getGroupImageIds(group)
    return imageIds.length > 0 && imageIds.every((id) => selectedVariants.includes(id))
  }, [selectedVariants])

  const toggleGroupSelection = useCallback((group) => {
    const imageIds = getGroupImageIds(group)
    const imageIdsSet = new Set(imageIds)

    setSelectedVariants((prev) => {
      const allSelected = imageIds.every((id) => prev.includes(id))

      if (allSelected) {
        return prev.filter((id) => !imageIdsSet.has(id))
      }

      const next = new Set(prev)
      imageIds.forEach((id) => next.add(id))
      return [...next]
    })
  }, [])

  // return
  return {
    selectedVariants,
    setSelectedVariants,
    getSelectedCountForVariant,
    getTotalCountForVariant,
    isGroupFullySelected,
    toggleGroupSelection,
  }
}
